import { render, staticRenderFns } from "./tmc-popup-content.vue?vue&type=template&id=5b8b216d&scoped=true"
import script from "./tmc-popup-content.vue?vue&type=script&lang=js"
export * from "./tmc-popup-content.vue?vue&type=script&lang=js"
import style0 from "./tmc-popup-content.vue?vue&type=style&index=0&id=5b8b216d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b216d",
  null
  
)

export default component.exports